import React from 'react';

import component, {classnames, makePath} from '../component';
import TopBanner from '../TopBanner';
import {HBox, VBox} from '../Box';
import Link from '../Link';
import HtmlContent from '../HtmlContent';


export default component('Feedback', {
  componentDidMount(){
    window._ues = {
      host:'arena4game.userecho.com',
      forum:'45354',
      lang:'ru',
      tab_corner_radius:5,
      tab_font_size:20,
      tab_image_hash:'ZmVlZGJhY2s%3D',
      tab_chat_hash:'Y2hhdA%3D%3D',
      tab_alignment:'right',
      tab_text_color:'#ffffff',
      tab_text_shadow_color:'#00000055',
      tab_bg_color:'#57a957',
      tab_hover_color:'#f45c5c',
      container_id:'ue-embedded-widget'
    };

    (function() {
      var s = document.getElementById(window._ues.container_id);
      var _ue = document.createElement('script');
      _ue.type = 'text/javascript';
      _ue.async = true;
      _ue.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.userecho.com/js/widget-1.4.gz.js';
      s.parentNode.insertBefore(_ue, s);
    })();
  },

  render() {
    return (
      <div className="Feedback">
        <TopBanner size="tiny"/>
        <HBox width={4}>
          <div id="ue-embedded-widget"></div>
        </HBox>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/pages/Feedback.js